import React, { Component } from "react";
import { Table, Modal, Form, Row, Col, Button, message, DatePicker, Tooltip } from "antd";
import "./Form.css";
import numeral from "numeral";
import moment from "moment-timezone";
import { maskDate } from "../utils/Masker";
import axios from "axios";
import InputForm from "./InputForm";
import TipoDocFrame from './TipoDocFrame';
import CtaCorrenteFrame from './CtaCorrenteFrame';
import Colors from '../utils/Colors';

const { Item: ItemForm } = Form;
const { Column } = Table;
const ButtonGroup = Button.Group;

export default class TituloLiquidarForm extends Component {
  state = {
    registro: [],
    carregando: false,
  };

  componentDidUpdate(propsAnterior) {
    if (this.props.registroParc !== propsAnterior.registroParc) {
      const registro = {
        ...this.props.registroParc,
        tparc_valor: this.props.registroParc.pgto_vlr_restante,
        pgto_vlr_desconto: this.props.registroParc.pgto_vlr_desconto || 0,
        pgto_vlr_acrescimo: this.props.registroParc.pgto_vlr_acrescimo || 0,
        tpp_perc_desconto: this.props.registroParc.tpp_perc_desconto || 0,
        checkParcial: this.props.registroParc.parcelas_pagtos && this.props.registroParc.parcelas_pagtos.length > 0 ? true : false,
        checkFinalizarParcela: false,
      };

      this.setState({
        registro: this.calculaVlrParc(registro),
      });
    }
  }


  sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  onLiquidarMultiplas = () => {
    const { registro } = this.state;

    const dataAtual = moment().format('YYYY-MM-DD');
    const pgtoData = moment(registro.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD');

    if (pgtoData > dataAtual) {
      Modal.warning({ title: 'Aviso!', content: 'Data de Pagamento maior que data atual.' });
      return;
    }

    if (!registro.tparc_tipo_doc || !registro.tparc_tipo_doc.key || registro.tparc_tipo_doc.key === '0') {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento' });
      return;
    }

    if (!registro.tparc_conta_corrente || !registro.tparc_conta_corrente.key || registro.tparc_conta_corrente.key === '0') {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente' });
      return;
    }

    if (!registro.parcelas || registro.parcelas.length === 0) {
      Modal.warning({ title: 'Aviso!', content: 'Nenhuma parcela selecionada.' });
      return;
    }

    const totalParcelas = registro.parcelas.reduce((total, parcela) => {
      return total + parseFloat(parcela.pgto_vlr_restante || 0);
    }, 0);

    const descontoTotal = parseFloat(registro.pgto_vlr_desconto || 0);
    const acrescimoTotal = parseFloat(registro.pgto_vlr_acrescimo || 0);

    if (descontoTotal < 0) {
      Modal.warning({ title: 'Aviso!', content: 'Desconto não pode ser negativo.' });
      return;
    }

    if (acrescimoTotal < 0) {
      Modal.warning({ title: 'Aviso!', content: 'Acréscimo não pode ser negativo.' });
      return;
    }

    if (descontoTotal > totalParcelas) {
      Modal.warning({ title: 'Aviso!', content: 'Desconto maior que o total das parcelas.' });
      return;
    }

    Modal.confirm({
      title: 'Confirmar Liquidação',
      content: `Deseja liquidar ${registro.parcelas.length} parcela(s) selecionada(s)?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: async () => {
        this.setState({ salvando: true });

        try {
          let descontoJaRateado = 0;
          let acrescimoJaRateado = 0;

          for (let i = 0; i < registro.parcelas.length; i++) {
            const parcela = registro.parcelas[i];
            const valorRestante = parseFloat(parcela.pgto_vlr_restante || 0);

            let descontoParcela = 0;
            let acrescimoParcela = 0;

            if (totalParcelas > 0) {
              if (i === registro.parcelas.length - 1) {
                descontoParcela = descontoTotal - descontoJaRateado;
                acrescimoParcela = acrescimoTotal - acrescimoJaRateado;
              } else {
                descontoParcela = parseFloat(((valorRestante / totalParcelas) * descontoTotal).toFixed(2));
                acrescimoParcela = parseFloat(((valorRestante / totalParcelas) * acrescimoTotal).toFixed(2));

                descontoJaRateado += descontoParcela;
                acrescimoJaRateado += acrescimoParcela;
              }
            }

            const valorPago = valorRestante - descontoParcela + acrescimoParcela;

            const percDesconto = valorRestante > 0
              ? (descontoParcela / valorRestante) * 100
              : 0;

            const payload = {
              ...parcela,
              pgto_data: pgtoData,
              tparc_tipo_doc: registro.tparc_tipo_doc.key,
              tparc_conta_corrente: registro.tparc_conta_corrente.key,

              tparc_valor: valorRestante,
              pgto_vlr_pago: parseFloat(valorPago.toFixed(2)),
              pgto_vlr_desconto: parseFloat(descontoParcela.toFixed(2)),
              pgto_vlr_acrescimo: parseFloat(acrescimoParcela.toFixed(2)),
              tpp_perc_desconto: parseFloat(percDesconto.toFixed(2)),

              checkParcial: false,
              checkFinalizarParcela: false,
            };

            await axios.put(
              `/titulos/liquidarParcela/${parcela.tit_idf}/${parcela.tparc_parcela}`,
              payload
            );

            await this.sleep(150);
          }

          this.setState({ salvando: false });
          message.success('Parcelas liquidadas com sucesso.');
          this.props.onLiquidarClick();

        } catch (error) {
          console.error(error.response || error);

          this.setState({ salvando: false });

          Modal.error({
            title: 'Falha - Atenção!',
            content: error.response && error.response.data
              ? 'Erro ao liquidar parcelas. ' + error.response.data
              : 'Erro ao liquidar parcelas.',
            okText: 'OK',
          });
        }
      }
    });
  };


  onOK = () => {
    // console.log('onOK Registro gravar: ', this.state.registro);

    if (this.state.registro.tipoTela === 'LIQ_MULT') {
      this.onLiquidarMultiplas();
      return;
    }

    this.setState({ salvando: true })

    if (this.state.registro.tparc_situacao === 'P') {

      axios.put(`/titulos/abrirParcela/${this.state.registro.tit_idf}/${this.state.registro.tparc_parcela}`)
        .then(response => {
          this.setState({
            formVisivel: false,
            salvando: false,
          })
          message.success('Parcela Aberto com sucesso.');
          this.props.onLiquidarClick();
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            salvando: false
          })

          if (error.response.status === 412) {
            Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', },
              this.props.onCancelarLiqClick()
            )
          } else {
            Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível abrir essa parcela. ' + error.response.data, okText: 'OK', },
              this.props.onCancelarLiqClick()
            )
          }
        })

    } else {

      const dataAtual = moment().format('YYYY-MM-DD');
      const dataEmiss = moment(this.state.registro.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD');
      if (dataEmiss > dataAtual) {
        Modal.warning({ title: 'Aviso!', content: 'Data de Pagamento maior que data atual.' });
        return;
      }
      if ((!this.state.registro.tparc_tipo_doc.key) || (this.state.registro.tparc_tipo_doc.key === '0') || (this.state.registro.tparc_tipo_doc.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento' });
        return;
      }
      if ((!this.state.registro.tparc_conta_corrente.key) || (this.state.registro.tparc_conta_corrente.key === '0') || (this.state.registro.tparc_conta_corrente.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente' });
        return;
      }
      if (this.state.registro.tparc_valor > this.state.registro.pgto_vlr_restante) {
        Modal.warning({ title: 'Aviso!', content: 'Valor Pagamento maior que valor da Parcela' });
        return;
      }

      this.state.registro.tparc_tipo_doc = this.state.registro.tparc_tipo_doc.key;
      this.state.registro.tparc_conta_corrente = this.state.registro.tparc_conta_corrente.key;
      this.state.registro.pgto_data = moment(this.state.registro.pgto_data, 'DD/MM/YYYY').format('YYYY-MM-DD');


      axios.put(`/titulos/liquidarParcela/${this.state.registro.tit_idf}/${this.state.registro.tparc_parcela}`, this.state.registro)
        .then(response => {
          this.setState({
            formVisivel: false,
            salvando: false,
          })
          message.success('Parcela Liquidada com sucesso.');
          this.props.onLiquidarClick();
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            salvando: false
          })

          if (error.response.status === 412) {
            Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', },
              this.props.onCancelarLiqClick()
            )
          } else {
            Modal.error({ title: 'Falha - Atenção!', content: 'Erro ao gravar. ' + error.response.data, okText: 'OK', },
              this.props.onCancelarLiqClick()
            )
          }

        })

    }

  };


  onExcluirPagtoClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este Pagamento?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/titulos/deletePagto/${registro.tpp_idf}/${registro.tpp_parcela}/${registro.tpp_seq}`)
          .then(response => {
            this.setState({
              formVisivel: false,
              salvando: false,
            })
            message.success('Pagamento Excluído com sucesso.');
            this.props.onLiquidarClick();
          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', },
                this.props.onCancelarLiqClick()
              )
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir esse pagamento. ' + error.response.data, okText: 'OK', },
                this.props.onCancelarLiqClick()
              )
            }
          })
      }
    })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['pgto_data'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ pgto_data: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['tparc_tipo_doc'] = event.tparc_tipo_doc;
    this.setState(event);
  }

  onChangeCtaCorrente = event => {
    const { registro } = this.state;
    registro['tparc_conta_corrente'] = event.tparc_conta_corrente;
    this.setState(event);
  }



  toNumber = value => {
    const n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  };

  onChangeValorParcela = event => {
    const { id, value } = event.target;

    this.setState(prevState => {
      let registro = {
        ...prevState.registro,
        [id]: value,
      };

      const valorParcela = this.toNumber(registro.tparc_valor);
      const acrescimo = this.toNumber(registro.pgto_vlr_acrescimo);

      let percDesc = this.toNumber(registro.tpp_perc_desconto);
      let vlrDesc = this.toNumber(registro.pgto_vlr_desconto);

      if (id === 'tpp_perc_desconto') {
        vlrDesc = valorParcela * (percDesc / 100);
      }

      if (id === 'pgto_vlr_desconto') {
        percDesc = valorParcela > 0 ? (vlrDesc / valorParcela) * 100 : 0;
      }

      const pgto_vlr_pago = valorParcela + acrescimo - vlrDesc;

      registro = {
        ...registro,
        tpp_perc_desconto: percDesc.toFixed(2),
        pgto_vlr_desconto: vlrDesc.toFixed(2),
        pgto_vlr_pago: pgto_vlr_pago.toFixed(2),
      };

      return { registro };
    });
  };

  onChangeValoresLote = event => {
    const { id, value } = event.target;

    this.setState(prevState => {
      let registro = {
        ...prevState.registro,
        [id]: value,
      };

      const totalParcelas = this.toNumber(registro.tparc_valor);

      let percDesc = this.toNumber(registro.tpp_perc_desconto);
      let vlrDesc = this.toNumber(registro.pgto_vlr_desconto);
      const vlrAcrescimo = this.toNumber(registro.pgto_vlr_acrescimo);

      if (id === 'tpp_perc_desconto') {
        vlrDesc = totalParcelas * (percDesc / 100);
      }

      if (id === 'pgto_vlr_desconto') {
        percDesc = totalParcelas > 0 ? (vlrDesc / totalParcelas) * 100 : 0;
      }

      const valorFinal = totalParcelas - vlrDesc + vlrAcrescimo;

      registro = {
        ...registro,
        tpp_perc_desconto: percDesc.toFixed(2),
        pgto_vlr_desconto: vlrDesc.toFixed(2),
        pgto_vlr_acrescimo: vlrAcrescimo.toFixed(2),
        pgto_vlr_pago: valorFinal.toFixed(2),
      };

      return { registro };
    });
  };


  calculaVlrParc = registroParam => {
    const registro = { ...registroParam };

    const valorParcela = this.toNumber(registro.tparc_valor);
    const acrescimo = this.toNumber(registro.pgto_vlr_acrescimo);

    let percDesc = this.toNumber(registro.tpp_perc_desconto);
    let vlrDesc = this.toNumber(registro.pgto_vlr_desconto);

    if (vlrDesc === 0 && percDesc > 0) {
      vlrDesc = valorParcela * (percDesc / 100);
    }

    if (vlrDesc > 0 && percDesc === 0) {
      percDesc = valorParcela > 0 ? (vlrDesc / valorParcela) * 100 : 0;
    }

    const pgto_vlr_pago = valorParcela + acrescimo - vlrDesc;

    return {
      ...registro,
      tpp_perc_desconto: percDesc.toFixed(2),
      pgto_vlr_desconto: vlrDesc.toFixed(2),
      pgto_vlr_pago: pgto_vlr_pago.toFixed(2),
    };
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {this.state.registro.tipoTela === 'CONS' ? null : (
          <Tooltip title="Excluir">
            <Button
              type="danger"
              size="small"
              placement="topLeft"
              onClick={() => this.onExcluirPagtoClick(registro)}
              icon="delete"
              loading={this.state.carregando}
            />
          </Tooltip>
        )}
      </ButtonGroup>
    );
  };



  render() {
    const { onCancelarLiqClick, visivel } = this.props;
    const { tit_controle, tit_numero, tit_valor, tit_data_emissao, situacao_titulo,
      pes_nome, pc_conta, pc_descricao, cp_descricao, tit_descricao, situacao_parcela,
      tparc_situacao, tparc_parcela, tparc_data_parcela, tparc_valor,
      tpp_perc_desconto, pgto_vlr_desconto, pgto_vlr_acrescimo, pgto_vlr_restante, pgto_vlr_pago, pgto_data,
      tparc_tipo_doc, td_descricao, tparc_conta_corrente, pgto_desc_cta_corrente,
      tipoTela, checkParcial, checkFinalizarParcela, parcelas_pagtos,
      parcelas
    } = this.state.registro;

    // console.log('TituloLiquidarForm.this.state: ', this.state);

    return (
      <Modal
        title={"Lançamento Financeiro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarLiqClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        {tipoTela === 'LIQ_MULT' ? null : (
          <Row style={{ marginTop: -10 }}>

            <div style={{ height: 30, paddingTop: 2, width: "100%", borderWidth: 1, backgroundColor: Colors.background }}>
              <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                Dados do Lançamento Financeiro
              </span>
            </div>

            <Row style={{ marginTop: 5, marginLeft: 10 }}>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Número: </span>
                <span> {tit_numero} </span>
              </Col>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Controle: </span>
                <span> {tit_controle} </span>
              </Col>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Valor Título: </span>
                <span> {this.renderValor(tit_valor)} </span>
              </Col>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Situação Título: </span>
                <span> {situacao_titulo} </span>
              </Col>
            </Row>
            <Row style={{ marginTop: 5, marginLeft: 10 }}>
              <Col xs={24} sm={18}>
                <span style={{ fontWeight: "bold" }}>Cliente/Fornec: </span>
                <span> {pes_nome} </span>
              </Col>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Data Emissão: </span>
                <span> {this.renderData(tit_data_emissao)} </span>
              </Col>
            </Row>
            <Row style={{ marginTop: 5, marginLeft: 10 }}>
              <Col xs={24} sm={12}>
                <span style={{ fontWeight: "bold" }}>Conta Financeira: </span>
                <span> {pc_conta + ' - ' + pc_descricao} </span>
              </Col>
              <Col xs={24} sm={12}>
                <span style={{ fontWeight: "bold" }}>Cond. Pagto: </span>
                <span> {cp_descricao} </span>
              </Col>
            </Row>
            <Row style={{ marginTop: 5, marginLeft: 10 }}>
              <Col xs={24}>
                <span style={{ fontWeight: "bold" }}>Descrição: </span>
                <span> {tit_descricao} </span>
              </Col>
            </Row>

          </Row>
        )}


        {(tparc_situacao === 'P') ? (
          <Row style={{ marginTop: 15, marginBottom: 15 }}>
            <div
              style={{ height: 30, paddingTop: 2, width: "100%", borderWidth: 1, backgroundColor: Colors.background }}
            >
              <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                Dados da Parcela
              </span>
            </div>

            <Row style={{ marginTop: 5, marginLeft: 10 }}>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Nº Parcela: </span>
                <span> {tparc_parcela} </span>
              </Col>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Data Venc: </span>
                <span> {this.renderData(tparc_data_parcela)} </span>
              </Col>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Valor Parc: </span>
                <span> {this.renderValor(tparc_valor)} </span>
              </Col>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Situação Parc: </span>
                <span> {situacao_parcela} </span>
              </Col>
            </Row>

            <Row style={{ marginTop: 5, marginLeft: 10 }}>
              <Col xs={24} sm={6}>
                <span style={{ fontWeight: "bold" }}>Data Pagto: </span>
                <span> {this.renderData(pgto_data)} </span>
              </Col>
              <Col xs={24} sm={9}>
                <span style={{ fontWeight: "bold" }}>Tipo Doc: </span>
                <span> {td_descricao} </span>
              </Col>
              <Col xs={24} sm={9}>
                <span style={{ fontWeight: "bold" }}>Cta Corrente: </span>
                <span> {pgto_desc_cta_corrente} </span>
              </Col>
            </Row>

            <Row style={{ marginTop: 5, marginLeft: 10 }}>
              <Col xs={24} sm={5}>
                <span style={{ fontWeight: "bold" }}>Valor Parc: </span>
                <span> {this.renderValor(tparc_valor)} </span>
              </Col>
              <Col xs={24} sm={4}>
                <span style={{ fontWeight: "bold" }}>% Desconto: </span>
                <span> {this.renderValor(tpp_perc_desconto)} </span>
              </Col>
              <Col xs={24} sm={5}>
                <span style={{ fontWeight: "bold" }}>Desconto: </span>
                <span> {this.renderValor(pgto_vlr_desconto)} </span>
              </Col>
              <Col xs={24} sm={5}>
                <span style={{ fontWeight: "bold" }}>Acréscimo: </span>
                <span> {this.renderValor(pgto_vlr_acrescimo)} </span>
              </Col>
              <Col xs={24} sm={5}>
                <span style={{ fontWeight: "bold" }}>Saldo: </span>
                <span> {this.renderValor(pgto_vlr_restante)} </span>
              </Col>
            </Row>
          </Row>
        ) : null}

        {(tipoTela === 'LIQ') && (tparc_situacao === 'A') ? (
          <Row style={{ marginTop: 15 }}>
            <div
              style={{ height: 30, paddingTop: 2, paddingBottom: 0, marginBottom: 0, width: "100%", borderWidth: 1, backgroundColor: Colors.background }}
            >
              <Col xs={12} style={{ paddingBottom: 0, marginBottom: 0 }}>
                <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                  Dados da Parcela
                </span>
              </Col>
              <Col xs={6} style={{}}>
                <div style={{ marginTop: -5 }}>
                  <InputForm
                    type="checkbox"
                    id="checkParcial"
                    ref="checkParcial"
                    onChange={this.onChange}
                    value={checkParcial ? true : false}
                    disabled={parcelas_pagtos.length}
                  >
                    Pagamento Parcial
                  </InputForm>
                </div>
              </Col>
              <Col xs={6} style={{ paddingBottom: 0, marginBottom: 0 }}>
                {checkParcial ? (
                  <div style={{ marginTop: -5 }}>
                    <InputForm
                      type="checkbox"
                      id="checkFinalizarParcela"
                      ref="checkFinalizarParcela"
                      onChange={this.onChange}
                      value={checkFinalizarParcela ? true : false}
                    >
                      Finalizar Parcela
                    </InputForm>
                  </div>
                ) : null}
              </Col>
            </div>

            <div style={{ marginTop: 0, marginLeft: 10, paddingTop: 0 }}>
              <Col xs={24} style={{ marginTop: -20 }}>
                <Col xs={24} sm={6} className="camposEspacoDireita">
                  <span>Parcela</span>
                  <InputForm
                    id="tparc_parcela"
                    ref="tparc_parcela"
                    value={tparc_parcela}
                    disabled={true}
                  />
                </Col>
                <Col xs={24} sm={6} className="camposEspacoDireita">
                  <span>Situação</span>
                  <InputForm
                    id="situacao_parcela"
                    ref="situacao_parcela"
                    value={situacao_parcela}
                    disabled={true}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: 4 }} className="camposEspacoDireita">
                  <span>Data Pagto</span>
                  <DatePicker
                    onChange={this.onDateChange}
                    format="DD/MM/YYYY"
                    showToday={true}
                    allowClear={false}
                    value={moment(pgto_data, "DD/MM/YYYY", true)}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xs={24} sm={6} style={{}}>
                  <span>Data Vencimento</span>
                  <InputForm
                    id="tparc_data_parcela"
                    ref="tparc_data_parcela"
                    value={moment(tparc_data_parcela).format('DD/MM/YYYY')}
                    disabled={true}
                  />
                </Col>
              </Col>

              <Col xs={24}>
                <Col xs={24} sm={5} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Valor Parcela</span>
                  <InputForm
                    type="number"
                    id="tparc_valor"
                    ref="tparc_valor"
                    value={tparc_valor}
                    onChange={this.onChangeValorParcela}
                    disabled={!checkParcial}
                  />
                </Col>
                <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>% Desconto</span>
                  <InputForm
                    type="number"
                    id="tpp_perc_desconto"
                    ref="tpp_perc_desconto"
                    value={tpp_perc_desconto}
                    onChange={this.onChangeValorParcela}
                  />
                </Col>
                <Col xs={24} sm={5} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Valor Desconto</span>
                  <InputForm
                    type="number"
                    id="pgto_vlr_desconto"
                    ref="pgto_vlr_desconto"
                    value={pgto_vlr_desconto}
                    onChange={this.onChangeValorParcela}
                  />
                </Col>
                <Col xs={24} sm={5} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Valor Acréscimo</span>
                  <InputForm
                    type="number"
                    id="pgto_vlr_acrescimo"
                    ref="pgto_vlr_acrescimo"
                    value={pgto_vlr_acrescimo}
                    onChange={this.onChangeValorParcela}
                  />
                </Col>
                <Col xs={24} sm={5} style={{ marginTop: -20 }}>
                  <span>Valor Pagto</span>
                  <InputForm
                    type="number"
                    id="pgto_vlr_pago"
                    ref="pgto_vlr_pago"
                    value={pgto_vlr_pago}
                    onChange={this.onChange}
                    disabled={true}
                  />
                </Col>
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                <TipoDocFrame
                  label="Tipo Documento"
                  id="tparc_tipo_doc"
                  value={tparc_tipo_doc}
                  width={"100%"}
                  onChange={this.onChangeTipoDoc}
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <CtaCorrenteFrame
                  label="Conta Corrente"
                  id="tparc_conta_corrente"
                  value={tparc_conta_corrente}
                  width={"100%"}
                  onChange={this.onChangeCtaCorrente}
                />
              </Col>
            </div>
          </Row>
        ) : null}


        {parcelas_pagtos && ((parcelas_pagtos.length > 1) || (parcelas_pagtos.length > 0 && tparc_situacao === 'A')) ? (
          <Row style={{ marginBottom: 20 }}>
            <div
              style={{ height: 30, paddingTop: 2, marginBottom: 8, width: "100%", borderWidth: 1, backgroundColor: Colors.background }}
            >
              <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                Pagamento Parcial
              </span>
            </div>

            <Table
              dataSource={parcelas_pagtos}
              pagination={false}
              rowKey={(parcelas_pagtos => parcelas_pagtos.tpp_seq)}
            >
              <Column
                key="tpp_data_pagto"
                dataIndex="tpp_data_pagto"
                title="Data Pagto"
                width={80}
                align="center"
                className="listaCadastro"
                render={this.renderData}
              />
              <Column
                key="tpp_valor"
                dataIndex="tpp_valor"
                title="Valor Pagto"
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="td_descricao"
                dataIndex="td_descricao"
                title="Documento"
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="cc_descricao"
                dataIndex="cc_descricao"
                title="Cta Corrente"
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                dataIndex="cc_descricao"
                title="."
                render={this.renderAcoes}
                width={70}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </Row>
        ) : null}


        {tipoTela === 'LIQ_MULT' ? (
          <Row style={{ marginTop: 15 }}>
            <div
              style={{
                height: 30,
                paddingTop: 2,
                width: "100%",
                borderWidth: 1,
                backgroundColor: Colors.background
              }}
            >
              <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                Parcelas Selecionadas
              </span>
            </div>

            <Table
              dataSource={parcelas || []}
              pagination={false}
              rowKey={registro => registro.tit_idf + '_' + registro.tparc_parcela}
              style={{ marginTop: 8 }}
            >
              <Column
                key="tparc_data_parcela"
                dataIndex="tparc_data_parcela"
                title="Data Venc"
                render={this.renderData}
                width={90}
                align="center"
              />
              <Column
                key="tparc_parcela"
                dataIndex="tparc_parcela"
                title="Parcela"
                width={80}
                align="center"
              />
              <Column
                key="tit_numero"
                dataIndex="tit_numero"
                title="Número"
                width={90}
                align="left"
              />
              <Column
                key="tit_descricao"
                dataIndex="tit_descricao"
                title="Descrição"
                width={180}
                align="left"
              />
              <Column
                key="pgto_vlr_restante"
                dataIndex="pgto_vlr_restante"
                title="Vlr Restante"
                render={this.renderValor}
                width={100}
                align="right"
              />
            </Table>

            {/* <Row style={{ marginTop: 10 }}>
              <Col xs={24}>
                <span style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, color: Colors.primary }}>
                  Total selecionado: {this.renderValor(tparc_valor)}
                </span>
              </Col>
            </Row> */}

            <Row style={{ marginTop: 30 }}>
              <Col xs={24} sm={5} className="camposEspacoDireita">
                <span>Total Selecionado</span>
                <InputForm
                  type="number"
                  id="vlr_total_parcelas"
                  value={tparc_valor}
                  disabled={true}
                />
              </Col>

              <Col xs={24} sm={4} className="camposEspacoDireita">
                <span>% Desconto</span>
                <InputForm
                  type="number"
                  id="tpp_perc_desconto"
                  value={tpp_perc_desconto}
                  onChange={this.onChangeValoresLote}
                />
              </Col>

              <Col xs={24} sm={5} className="camposEspacoDireita">
                <span>Desconto Total</span>
                <InputForm
                  type="number"
                  id="pgto_vlr_desconto"
                  value={pgto_vlr_desconto}
                  onChange={this.onChangeValoresLote}
                />
              </Col>

              <Col xs={24} sm={5} className="camposEspacoDireita">
                <span>Acréscimo Total</span>
                <InputForm
                  type="number"
                  id="pgto_vlr_acrescimo"
                  value={pgto_vlr_acrescimo}
                  onChange={this.onChangeValoresLote}
                />
              </Col>

              <Col xs={24} sm={5}>
                <span>Total a Pagar</span>
                <InputForm
                  type="number"
                  id="pgto_vlr_pago"
                  value={pgto_vlr_pago}
                  disabled={true}
                />
              </Col>
            </Row>

            <Row style={{  }}>
              <Col xs={24} sm={8} className="camposEspacoDireita">
                <span>Data Pagto</span>
                <DatePicker
                  onChange={this.onDateChange}
                  format="DD/MM/YYYY"
                  showToday={true}
                  allowClear={false}
                  value={moment(pgto_data, "DD/MM/YYYY", true)}
                  style={{ width: "100%" }}
                />
              </Col>

              <Col xs={24} sm={8} className="camposEspacoDireita">
                <TipoDocFrame
                  label="Tipo Documento"
                  id="tparc_tipo_doc"
                  value={tparc_tipo_doc}
                  width={"100%"}
                  onChange={this.onChangeTipoDoc}
                />
              </Col>

              <Col xs={24} sm={8}>
                <CtaCorrenteFrame
                  label="Conta Corrente"
                  id="tparc_conta_corrente"
                  value={tparc_conta_corrente}
                  width={"100%"}
                  onChange={this.onChangeCtaCorrente}
                />
              </Col>
            </Row>
          </Row>
        ) : null}

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {(tipoTela === 'LIQ' || tipoTela === 'LIQ_MULT') ? (
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.onOK}
                    className="btn-salvar"
                    style={{ width: 130 }}
                  >
                    {tipoTela === 'LIQ_MULT'
                      ? 'Liquidar Todas'
                      : situacao_parcela === 'PAGO'
                        ? 'Abrir Parcela'
                        : 'Liquidar'}
                  </Button>
                ) : null}

                <Button
                  htmlType="button"
                  onClick={onCancelarLiqClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TituloLiquidarForm.js